import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useData } from '../../contexts/DataContext';
import GuestPageForm from './GuestPageForm';
import GuestPageList from './GuestPageList';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiPlus } = FiIcons;

const GuestPageManager = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingPage, setEditingPage] = useState(null);
  const { properties } = useData();

  const handleEdit = (page) => {
    setEditingPage(page);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditingPage(null);
  };

  if (properties.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4">
          <SafeIcon icon={FiPlus} className="text-gray-400 text-3xl" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">No Properties Found</h3>
        <p className="text-gray-500 mb-6 max-w-sm">You need to add properties before creating guest pages.</p>
        <button
          onClick={() => window.location.href = '#/properties'}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-medium transition-colors duration-200 shadow-lg shadow-blue-200"
        >
          Add Your First Property
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-xl font-bold text-gray-800">Guest Pages</h2>
          <p className="text-sm text-gray-500">Manage guest portals</p>
        </div>
        <motion.button
          onClick={() => setShowForm(true)}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-xl shadow-lg shadow-blue-200 transition-all duration-200"
        >
          <SafeIcon icon={FiPlus} />
          <span className="font-medium">Create Guest Page</span>
        </motion.button>
      </div>

      {showForm ? (
        <GuestPageForm guestPage={editingPage} onClose={handleCloseForm} />
      ) : (
        <GuestPageList onEdit={handleEdit} />
      )}
    </div>
  );
};

export default GuestPageManager;